import { type FC } from 'react';
import type { CheckboxProps } from './types';
import { Checkbox as ChakraUiCheckbox } from '@chakra-ui/react';
import { Check } from '@/components/Media/Icon';
import { colors } from '@/styles/theme/constants';

interface CustomIconProps {
  isIndeterminate?: boolean
  isChecked?: boolean
}

const CustomIcon: FC<CustomIconProps> = ({ isIndeterminate, isChecked, ...rest }) => {
  return (
    <>
      {isChecked ? (
        <Check fill={colors.shade09} {...rest} />
      ) : null}
    </>
  )
}

export const Checkbox: FC<CheckboxProps> = ({ children, ...props }) => {
  return (
    <ChakraUiCheckbox
      size="lg"
      variant="red03"
      icon={<CustomIcon />}
      iconSize="18px"
      sx={{
        '& .chakra-checkbox__control': {
          width: '18px',
          height: '18px',
        },
      }}
      {...props}
    >
      {children}
    </ChakraUiCheckbox>
  )
}
